module.exports = __webpack_public_path__ + "img/open-apis.9b7f63e2.svg";